import store from '@/store';
import axios from 'axios';
import _ from 'lodash';

export default {
  async getCountryAws(start) {
    try {
      let resp = await axios.get('/whereami');
      this.changeCountryLanguage(resp.data.country);
      start();
    } catch (error) {}
  },
  changeCountryLanguage(country) {
    this.changeCountry(country);
    this.changeLanguate(country);
  },
  changeCountry(country) {
    store.commit('CHANGE_CITY_ORDER', country);
  },
  changeLanguate(country) {
    let spanishCountries = store.state.spanishCountries;

    if (_.indexOf(spanishCountries, country) !== -1) {
      let countryExists = _.find(store.state.cities, (item) => {
        return item.country === country;
      });

      if (typeof countryExists !== 'undefined') {
        store.commit('CHANGE_LANG_SELECTED', {
          langSelected: `es-${country}`,
          init: false
        });
      } else {
        store.commit('CHANGE_LANG_SELECTED', {
          langSelected: `es-ES`,
          init: false
        });
      }
    } else if (country === 'BR') {
      store.commit('CHANGE_LANG_SELECTED', {
        langSelected: `pt-${country}`,
        init: false
      });
    } else if (country === 'CA') {
      store.commit('CHANGE_LANG_SELECTED', {
        langSelected: `ca-ES`,
        init: false
      });
    } else {
      store.commit('CHANGE_LANG_SELECTED', {
        langSelected: 'en-GB',
        init: false
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/localeService.js